
/* ARSHÉ MOBILE CRO — navigation, sticky CTA, product controls */
(function () {
  'use strict';

  function initMobileMenu() {
    var drawer = document.querySelector('[data-arshe-mobile-menu-v2]');
    var openBtn = document.querySelector('.arshe-menu-toggle');

    if (!drawer || !openBtn) return;

    var closeTargets = drawer.querySelectorAll('[data-arshe-mobile-menu-v2-close]');
    var panel = drawer.querySelector('.arshe-mobile-menu-v2__panel');
    var lastFocused = null;
    var scrollTop = 0;

    function lockBody() {
      scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('arshe-mobile-menu-v2-open');
      document.body.classList.add('arshe-mobile-menu-v2-open');
    }

    function unlockBody() {
      document.documentElement.classList.remove('arshe-mobile-menu-v2-open');
      document.body.classList.remove('arshe-mobile-menu-v2-open');
      window.scrollTo(0, scrollTop);
    }

    function openMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (drawer.classList.contains('is-open')) return;

      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      openBtn.setAttribute('aria-label', 'Close menu');
      lockBody();

      window.setTimeout(function () {
        var close = drawer.querySelector('.arshe-mobile-menu-v2__close');
        if (close) close.focus({ preventScroll: true });
      }, 80);
    }

    function closeMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.setAttribute('aria-label', 'Open menu');
      unlockBody();

      if (lastFocused && typeof lastFocused.focus === 'function') {
        window.setTimeout(function () {
          lastFocused.focus({ preventScroll: true });
        }, 30);
      }
    }

    /*
     * HAMBURGER IS A PURE UI CONTROL.
     *
     * This handler is deliberately installed at document-capture level so
     * no legacy delegated/section handler can treat the hamburger as a link
     * or close the current surface first. In particular, never call
     * history.pushState(), location.assign(), or navigate when opening the
     * drawer.
     */
    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest ? event.target.closest('.arshe-menu-toggle') : null;
      if (!trigger || trigger !== openBtn) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openMenu();
    }, true);

    closeTargets.forEach(function (target) {
      target.addEventListener('click', closeMenu);
    });

    /* Direct menu navigation: close the drawer and navigate in the same
       event turn. The old delayed close allowed the homepage layer to paint
       for a frame before the destination loaded (Home -> Destination flash). */
    drawer.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        /* IMPORTANT: do not close/unlock the drawer before navigation.
           The drawer is sitting over the homepage when a Moment is open;
           closing it first reveals that homepage for a frame. Leave the
           current surface intact and navigate immediately so the browser
           replaces the document without ever exposing the underlying page. */
        event.preventDefault();
        drawer.setAttribute('data-arshe-navigation-pending', 'true');
        window.location.assign(href);
      });
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) closeMenu(event);
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeMenu(event);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary'
      );

      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  }

  function initStickyPurchase() {
    var productBar = document.getElementById('arsheProductSticky');

    

    if (productBar && !document.querySelector('[data-arshe-gallery]')) {
      var form = document.getElementById('arsheProductForm');
      function updateProductBar() {
        if (window.innerWidth > 899 || !form) {
          productBar.classList.remove('is-visible');
          productBar.setAttribute('aria-hidden','true');
          return;
        }
        var rect = form.getBoundingClientRect();
        var show = rect.bottom < 80;
        productBar.classList.toggle('is-visible', show);
        productBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      window.addEventListener('scroll', updateProductBar, {passive:true});
      window.addEventListener('resize', updateProductBar, {passive:true});
      updateProductBar();
      var stickyLink = productBar.querySelector('.arshe-product-sticky__button');
      if (stickyLink && form) stickyLink.addEventListener('click', function(e){
        e.preventDefault();
        var checkout = form.querySelector('.shopify-payment-button__button');
        if (checkout) checkout.click();
        else { form.scrollIntoView({behavior:'smooth', block:'center'}); }
      });
    }
  }

  function initProductControls() {
    if (document.querySelector('[data-arshe-gallery]')) return;
    var form = document.querySelector('.arshe-product__form');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var variants = form.querySelectorAll('.arshe-product__variant');
    variants.forEach(function (button) {
      button.addEventListener('click', function () {
        variants.forEach(function (b) { b.classList.remove('active'); });
        button.classList.add('active');
        var id = button.getAttribute('data-variant-id');
        if (id && idInput) idInput.value = id;

        var price = button.getAttribute('data-price');
        if (price) {
          var priceEl = document.querySelector('.arshe-product__price-current');
          if (priceEl) priceEl.textContent = price;
        }
      });
    });

    var qtyInput = form.querySelector('.arshe-product__quantity-input');
    form.querySelectorAll('.arshe-product__quantity-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var current = parseInt(qtyInput.value, 10) || 1;
        var next = button.getAttribute('data-action') === 'increase' ? current + 1 : Math.max(1, current - 1);
        qtyInput.value = next;
      });
    });

    var thumbs = document.querySelectorAll('.arshe-product__thumb');
    var mainImage = document.querySelector('.arshe-product__image');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (img && mainImage) {
          mainImage.src = img.src.replace(/width=\d+/,'width=1600');
          mainImage.alt = img.alt || mainImage.alt;
        }
      });
    });
  }

  function initRobustLinks() {
    document.querySelectorAll('.arshe-product-card__media, .arshe-product-card__link').forEach(function(a){
      a.addEventListener('click', function(e){
        var href=a.getAttribute('href');
        if (!href || href === '#') return;
        e.stopPropagation();
        window.location.assign(href);
      }, false);
    });

    document.querySelectorAll('.arshe-fragrance-card__media, .arshe-fragrance-card__purchase a').forEach(function(a){
      a.addEventListener('click', function(e){
        var href=a.getAttribute('href');
        if (!href || href === '#') return;
        e.stopPropagation();
        window.location.assign(href);
      }, false);
    });
  }


  function initPremiumMotion() {
    var hero = document.querySelector('.arshe-hero');
    var heroVisual = document.querySelector('.arshe-hero__visual');
    var heroImage = document.querySelector('.arshe-hero__image-wrapper');
    if (!hero || !heroVisual || !heroImage) return;

    if (window.matchMedia('(min-width: 900px) and (pointer: fine)').matches) {
      var raf = 0;
      hero.addEventListener('pointermove', function(e) {
        var rect = heroVisual.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - .5;
        var y = (e.clientY - rect.top) / rect.height - .5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function() {
          heroImage.style.transform =
            'translate3d(' + (x * 7).toFixed(2) + 'px,' +
            (y * 5).toFixed(2) + 'px,0) rotateY(' + (x * -1.8).toFixed(2) +
            'deg) rotateX(' + (y * 1.4).toFixed(2) + 'deg)';
        });
      });
      hero.addEventListener('pointerleave', function() {
        cancelAnimationFrame(raf);
        heroImage.style.transform = '';
      });
    }

    if (window.matchMedia('(max-width: 899px)').matches) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            heroImage.classList.add('arshe-hero-image-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold:.15});
      observer.observe(heroImage);
    }
  }

  function initJudgeMeReviewModalGuard() {
    var body = document.body;
    if (!body || body.dataset.arsheJudgeMeGuard === '1') return;
    body.dataset.arsheJudgeMeGuard = '1';

    function hasVisibleReviewModal() {
      var selectors = [
        '.jm-mfp-wrap',
        '.jdgm-write-review-modal',
        '.jdgm-modal',
        '.jdgm-popup'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          var el = nodes[j];
          var style = window.getComputedStyle(el);
          var rect = el.getBoundingClientRect();
          if (style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity || '1') > 0 && rect.width > 0 && rect.height > 0) {
            return true;
          }
        }
      }
      return false;
    }

    function sync() {
      body.classList.toggle('arshe-judgeme-review-open', hasVisibleReviewModal());
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest && event.target.closest('.jdgm-write-rev, .jdgm-write-rev-link, .jdgm-write-review, [data-jdgm-write-review]');
      if (trigger) {
        window.setTimeout(sync, 50);
        window.setTimeout(sync, 250);
        window.setTimeout(sync, 700);
      }
    }, true);

    var observer = new MutationObserver(function() {
      window.requestAnimationFrame(sync);
    });
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden']});

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') window.setTimeout(sync, 50);
    }, true);

    sync();
  }

  function initCheckoutRouting() {
    function goToCheckout(event) {
      var target = event.target.closest('[data-arshe-checkout]');
      if (!target) return;
      if (target.getAttribute('aria-disabled') === 'true' || target.classList.contains('is-disabled')) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign((window.ARSHE_AJAX && window.ARSHE_AJAX.checkoutUrl) || '/checkout');
    }

    document.addEventListener('click', goToCheckout, true);

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('form#cart');
      if (!form) return;
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign((window.ARSHE_AJAX && window.ARSHE_AJAX.checkoutUrl) || '/checkout');
    }, true);
  }

  function init() {
    initCheckoutRouting();
    initJudgeMeReviewModalGuard();
    initMobileMenu();
    initStickyPurchase();
    initProductControls();
    initRobustLinks();
    initPremiumMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
